var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInhouseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 2H6.7619V11.1102L12.4762 7.30071V11.1102L18.1905 7.30071V10.8504L22 7.04085V22H2V2ZM2.95238 2.95238V21.0476H21.0476V9.3401L17.2381 13.1496V9.08025L11.5238 12.8898V9.08025L5.80952 12.8898V2.95238H2.95238Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInhouseIcon);
export default __webpack_public_path__ + "static/media/inhouseIcon.ac1fb34e6b9c47e5ae4e48f1d4f08e47.svg";
export { ForwardRef as ReactComponent };